// theme.js
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    backgroundColor: "transparent",
                    border: "0.5px solid #00cfff",
                    color: "#00ffd8",
                    textTransform: "none",
                    fontSize: 14,
                    height:50.25,
                    "&:hover": {
                        backgroundColor: "rgba(0,255,255,0.1)", // light #00ffd8 on hover
                        borderColor: "#00f6ff",
                    },
                },
            },
            variants: [
                {
                    props: { variant: "customContained" },
                    style: {
                        backgroundColor: "#313743",
                        color: "00cfff",
                        border: "none",
                        borderRadius: 10,
                        textTransform: "none",
                        backdropFilter: "blur(4px)",
                        WebkitBackdropFilter: "blur(4px)",
                        minWidth: 35,
                        height: 45,
                        "&:hover": {
                            backgroundColor: "rgba(58, 58, 58, 0.9)",
                            borderColor: "#00f6ff",
                        },
                        "&:disabled": {
                            backgroundColor: "rgba(58, 58, 58, 0.3)",
                            color: "#888",
                            borderColor: "#555",
                        },
                    },
                },
            ],
        },

        MuiTextField: {
            defaultProps: {
                variant: "outlined",
            },
            variants: [
                {
                    props: { variant: "standard" },
                    style: {
                        "& .MuiInput-root": {
                            color: "white",
                            backgroundColor: "rgba(255, 255, 255, 0.0)",
                            borderBottom: "1px solid #00f6ff",
                            paddingLeft: 8,
                            paddingRight: 8,
                            backdropFilter: "blur(4px)",
                            WebkitBackdropFilter: "blur(4px)",
                            fontSize:12,
                            transition: "border-color 0.3s ease",

                            "&:hover:not(.Mui-disabled):before": {
                                borderBottom: "1px solid #00f6ff",
                            },
                            "&:after": {
                                borderBottom: "2px solid #00f6ff",
                            },
                            "& input": {
                                color: "#00f6ff",
                            },
                        },
                        "& .MuiInputLabel-root": {
                            color: "#00f6ff",
                            fontSize: "12px",
                        },
                    },
                },
            ],
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    backgroundColor: "rgba(58, 58, 58, 0.73)",
                    color: "#00cfff",
                    fontSize: 12,
                    "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#00cfff",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#00ffff",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#00ffff",
                        borderWidth: 0.5,
                    },
                },
                input: {
                    color: "#00cfff", // text color
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    color: "#00cfff",
                    fontSize: 12,
                    "&.Mui-focused": {
                        color: "#00cfff",
                    },
                },
            },
        },

        MuiCheckbox: {
            styleOverrides: {
                root: {
                    color: "#00cfff", // unchecked color
                    "&.Mui-checked": {
                        color: "#00cfff", // checked color
                    },
                    "&:hover": {
                        backgroundColor: "rgba(128, 128, 128, 0.1)", // light blurry grey on hover
                        backdropFilter: "blur(4px)",
                        WebkitBackdropFilter: "blur(4px)",
                        borderRadius: 10,
                    },
                    "& .MuiSvgIcon-root": {
                        fontSize: 14, // ⬅️ Controls the checkbox size
                    },
                },
            },
        },

        MuiRadio: {
            styleOverrides: {
                root: {
                    color: "cyan", // default (unchecked)
                    "&.Mui-checked": {
                        color: "cyan", // checked
                    },
                    "&:hover": {
                        backgroundColor: "rgba(128, 128, 128, 0.1)",
                        backdropFilter: "blur(4px)",
                        WebkitBackdropFilter: "blur(4px)",
                        borderRadius: 4,
                    },
                },
            },
        },

        MuiFormControlLabel: {
            styleOverrides: {
                label: {
                    color: "#00cfff",
                    fontSize: "9px",
                },
            },
        },
    },
});

export default theme;
